import common from '../common'

export default {
    strategyHospital4Strategy(params) {
        return common.get('/rocheManage/bus/busStrategyHospital/exportXls', params, {responseType: 'blob'});
    },
    strategyOffice(params) {
        return common.get('/rocheManage/bus/busStrategyOffice/exportXls', params, {responseType: 'blob'});
    },
    strategyHospital4Hospital(params) {
        return common.get('/rocheManage/bus/busStrategyHospital/exportStrategyHospitalXls', params, {responseType: 'blob'});
    },
    speakerMeetingType(params) {
        return common.get('/rocheManage/bus/busSpeakerMeetingType/exportXls', params, {responseType: 'blob'});
    },  
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/scoreExport.js